import * as React from "react"
import { Script } from "gatsby"

// Use base URL of Marketo Landing Pages to prevent ad-blockers from disabling form script
const marketoBaseUrl = `//${process.env.GATSBY_MKTO_LP_DOMAIN}`
const munchkinId = process.env.GATSBY_MKTO_MUNCHKIN_ID

export default function MarketoScript(props) {
  return (
    <Script
      src={`${marketoBaseUrl}/js/forms2/js/forms2.min.js`}
      strategy="idle"
      onLoad={() => onLoad(props)}
    />
  )
}

function onLoad({ formId, onSubmitCallback }) {
  window.MktoForms2.setOptions({
    formXDPath: `/rs/${munchkinId}/images/marketo-xdframe-relative.html`,
  })
  window.MktoForms2.loadForm(
    marketoBaseUrl,
    munchkinId,
    formId,
    onSubmitCallback
  )
  window.MktoForms2.whenRendered((form) => destyleMktoForm(form))
}

function destyleMktoForm(mktoForm, moreStyles) {
  const formEl = mktoForm.getFormElem()[0]

  // remove element styles from <form> and children
  const styledEls = Array.from(formEl.querySelectorAll("[style]")).concat(
    formEl
  )

  styledEls.forEach((el) => el.removeAttribute("style"))

  // disable remote stylesheets and local <style>s
  const styleSheets = Array.from(document.styleSheets)

  styleSheets.forEach((ss) => {
    if (formEl.contains(ss.ownerNode)) {
      ss.disabled = true
    }
  })

  if (!moreStyles) formEl.setAttribute("data-styles-ready", "true")
}
